export type CleaningPackageData = {
  id: number;
  name: string;
  slug?: string;
  description: string;
}

export const single : Array<CleaningPackageData> = [
  {
    id: 1,
    name: 'Design with Time',
    slug: 'one-time/design-with-time/',
    description: "Our Design with Time Cleaning Package is perfect for homeowners looking for a one-time clean or occasional services. It's like creating your own custom cleaning plan! With sessions lasting from 2 to 5 hours, your cleaning team will tackle your tasks based on your priorities. We'll strive to finish everything on your list within the time frame you've chosen. Our teams are motivated to deliver top-notch results, so they'll work efficiently to complete your tasks within the allotted time. Keep in mind, you're paying for time that can vary based on the complexity of the job. If we need more time, we'll gladly work with you to schedule additional hours. Have a lengthy to-do list? Explore our Deep Clean Package for a more comprehensive cleaning experience.",
  },
  {
    id: 9,
    name: 'Deep Clean',
    slug: 'one-time/deep-cleaning/',
    description: 'Our Deep Cleaning Package is the most thorough cleaning service. The most significant difference between the Deep Cleaning Package and our other cleaning packages is the amount of time and detail we spend cleaning what we refer to as your vertical surfaces. Vertical surfaces include baseboards, trim work, interior windows, blinds, exterior cabinets/drawers, light fixtures, and doors.',
  },
  {
    id: 17,
    name: 'Move In/Move Out',
    slug: 'one-time/move/',
    description: 'Our Empty Home Move In/Out Cleaning Package is perfect for the homeowner who needs a vacant home, apartment, or condo cleaned. This package will help ensure your home is move-in ready! To ensure the highest quality of service, personal belongings must be removed prior to your cleaning.',
  },
];

export const weekly : Array<CleaningPackageData> = [
  {
    id: 6,
    name: 'Premium Weekly',
    slug: 'recurring/premium/',
    description: "The Premium Maintenance Cleaning is for customers who desire a home cleaning on a regular basis and offers thorough cleaning for key areas such as kitchens, bathrooms, bedrooms, and common areas, with a proven system to maintain an overall high standard of cleanliness. It's best to start services with a Deep Clean to tackle any build up and give your home a fresh start. ",
  },
  {
    id: 10,
    name: 'Alternating Weekly',
    slug: 'recurring/alternating/',
    description: 'With the Alternating Cleaning Package we are able to alternate your cleaning services between our Premium and Touch-Up cleaning services.\nThis specific cleaning package is best suited for the homeowner who does not require detailed cleaning on a regular basis, but still wishes to receive high quality house cleaning once a week, or every other week. With this package, our team of Personal House Cleaners will rotate between the Premium and Touch Up service packages, performing tasks related to each service during each visit. Please review the descriptions for the Premium and Touch Up packages to fully understand what is offered in each alternating service.',
  },
];

export const biweekly : Array<CleaningPackageData> = [
  {
    id: 5,
    name: 'Premium Biweekly',
    slug: 'recurring/premium/',
    description: "The Premium Maintenance Cleaning is for customers who desire a home cleaning on a regular basis and offers thorough cleaning for key areas such as kitchens, bathrooms, bedrooms, and common areas, with a proven system to maintain an overall high standard of cleanliness. It's best to start services with a Deep Clean to tackle any build up and give your home a fresh start. ",
  },
  {
    id: 2,
    name: 'Alternating Biweekly',
    slug: 'recurring/alternating/',
    description: 'With the Alternating Cleaning Package we are able to alternate your cleaning services between our Premium and Touch-Up cleaning services.\nThis specific cleaning package is best suited for the homeowner who does not require detailed cleaning on a regular basis, but still wishes to receive high quality house cleaning once a week, or every other week. With this package, our team of Personal House Cleaners will rotate between the Premium and Touch Up service packages, performing tasks related to each service during each visit. Please review the descriptions for the Premium and Touch Up packages to fully understand what is offered in each alternating service.',
  },
];
export const monthly: Array<CleaningPackageData> = [
  {
    id: 4,
    name: 'Premium Monthly',
    slug: 'recurring/premium/',
    description: "The Premium Maintenance Cleaning is for customers who desire a home cleaning on a regular basis and offers thorough cleaning for key areas such as kitchens, bathrooms, bedrooms, and common areas, with a proven system to maintain an overall high standard of cleanliness. It's best to start services with a Deep Clean to tackle any build up and give your home a fresh start. ",
  },
];
export const allPackages : Array<CleaningPackageData> = [
  ...single, ...weekly, ...biweekly, ...monthly,
];

export const getPackageById = (packageId: number): CleaningPackageData => {
  const packages = allPackages.filter(({ id }) => id === packageId);
  if (packages.length === 1) return packages[0];
  return ({
    id: -1,
    name: 'No Package Selected',
    description: '',
  });
};

export default ({
  single, weekly, biweekly, monthly,
});
